'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// Compares two date objects as returned from API.
var isBefore = function isBefore(a, b) {
  var timePeriods = ['year', 'month', 'day', 'hour', 'minute', 'second'];
  var isSame = timePeriods.reduce(function (acc, curr) {
    return Object.assign({}, acc, _defineProperty({}, curr, a[curr] === b[curr]));
  }, {});
  var notSame = timePeriods.find(function (period) {
    return !isSame[period];
  });
  if (typeof notSame !== 'undefined') {
    return a[notSame] < b[notSame];
  }
  return false;
};
exports.default = isBefore;